export default __webpack_public_path__ + "static/media/facts.3fd2dbce.png";